import * as CryptoJS from 'crypto-js';

const ENCRYPTION_KEY = 'NEBULA_EMR_SECURE_STORAGE_KEY_v1';

export function encryptToStorage<T>(data: T): string {
    return CryptoJS.AES.encrypt(JSON.stringify(data), ENCRYPTION_KEY).toString();
}

export function decryptFromStorage<T>(cipherText: string): T | null {
    try {
        const bytes = CryptoJS.AES.decrypt(cipherText, ENCRYPTION_KEY);
        const decrypted = bytes.toString(CryptoJS.enc.Utf8);
        if (!decrypted) return null;
        return JSON.parse(decrypted) as T;
    } catch {
        return null;
    }
}
